<template>
  <IconWrapper name="camera" :color="color" fillMode="fill">
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.74512 7.60791H19.8872V9.10791H8.74512V7.60791Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 8.29792C3.5 6.43657 5.01861 4.93652 6.88019 4.93652C8.74178 4.93652 10.2604 6.43657 10.2604 8.29792C10.2604 10.1593 8.74178 11.6593 6.88019 11.6593C5.01861 11.6593 3.5 10.1593 3.5 8.29792ZM6.88019 6.43652C5.83687 6.43652 5 7.27512 5 8.29792C5 9.32071 5.83687 10.1593 6.88019 10.1593C7.92351 10.1593 8.76039 9.32071 8.76039 8.29792C8.76039 7.27512 7.92351 6.43652 6.88019 6.43652Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7549 17.2207H4.61285V18.7207H15.7549V17.2207Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 17.9102C21 16.0489 19.4814 14.5488 17.6198 14.5488C15.7582 14.5488 14.2396 16.0489 14.2396 17.9102C14.2396 19.7716 15.7582 21.2716 17.6198 21.2716C19.4814 21.2716 21 19.7716 21 17.9102ZM17.6198 16.0488C18.6631 16.0488 19.5 16.8874 19.5 17.9102C19.5 18.933 18.6631 19.7716 17.6198 19.7716C16.5765 19.7716 15.7396 18.933 15.7396 17.9102C15.7396 16.8874 16.5765 16.0488 17.6198 16.0488Z"
        fill="black"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
